import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/login.scss";
import Loader from "../components/Loader";
import logo from "../access/img/MetrIQlogo.png";
import { API_BASE_URL } from "../config";

import { Button, TextField, Typography } from "@mui/material";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const navigate = useNavigate();

  // Auto-redirect if already logged in and verified
  useEffect(() => {
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("role");
    const isVerified = localStorage.getItem("isVerified");

    if (token && isVerified === "true") {
      if (role === "admin") {
        navigate("/admin/dashboard");
      } else {
        navigate("/user/dashboard");
      }
    }
  }, []);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 900);
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch(`${API_BASE_URL}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ email, password }),
      });

      const contentType = res.headers.get("content-type");
      if (!contentType || !contentType.includes("application/json")) {
        throw new Error("Invalid server response");
      }

      const data = await res.json();
      if (res.ok) {
        localStorage.setItem("userId", data.userId);
        localStorage.setItem("role", data.role);
        navigate("/verify", { state: { userId: data.userId } });
        return;
      } else {
        setMessage(data.error || "Login failed");
      }
    } catch (err) {
      console.error(err);
      setMessage("Server error or invalid response.");
    } finally {
      setLoading(false);
    }
  };

  // Styles
  const wrapperStyle = {
    display: "flex",
    width: "100%",
    paddingTop: 40,
    alignItems: "center",
    flexDirection: "column",
    minHeight: "100vh",
    position: "relative",
  };

  const cardStyle = {
    width: "100%",
    maxWidth: 540,
    borderRadius: 16,
    background: "#fff",
    padding: "50px",
  };

  return (
    <div style={wrapperStyle}>
      <img
        style={{ width: 250, marginBottom: 50 }}
        src={logo}
        alt="Logo Vista"
      />

      <div style={cardStyle}>
        <div style={{ marginBottom: 8, textAlign: "center" }}>
          <h2
            style={{
              margin: "0 0 20px 0",
              fontSize: 30,
              lineHeight: 1.2,
              fontWeight: 500,
            }}
          >
            Welcome to Metr.IQ!
          </h2>
          <p style={{ margin: "0 0 20px 0", color: "#6b7280" }}>
            Please sign in to your account.
          </p>
        </div>

        <form
          onSubmit={handleLogin}
          style={{ display: "flex", flexDirection: "column", gap: 30 }}
        >
          <TextField
            type="email"
            label="Email"
            placeholder="your@email.com"
            value={email}
            required
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
          />
          <TextField
            label="Password"
            type="password"
            placeholder="••••••••"
            value={password}
            required
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
          />

          <Button
            type="submit"
            disabled={loading}
            sx={{
              background: "var(--gradient-color)",
              color: "#fff",
              padding: "15px 0",
              fontWeight: 600,
              borderRadius: "30px",
              textTransform: "none",
              transition: "1s",
              "&:hover": { background: "var(--primary-color)" },
            }}
            fullWidth
          >
            {loading ? <Loader size="18px" color="#fff" /> : "Sign in"}
          </Button>
        </form>

        {message && (
          <p
            className="error"
            style={{
              marginTop: 12,
              color: "#dc2626",
              textAlign: "center",
              fontSize: 14,
              fontWeight: "600",
            }}
          >
            {message}
          </p>
        )}
      </div>

      {/* Footer */}
      <Typography
        variant="caption"
        sx={{
          position: "absolute",
          bottom: 50,
          textAlign: "center",
          width: "100%",
          color: "#9ca3af",
          fontSize: 13,
        }}
      >
        © {new Date().getFullYear()} Helmchron | Metr.IQ Platform
      </Typography>
    </div>
  );
}

export default Login;
